import React from 'react';
import { Link } from 'react-router-dom';

export default function EulaPage() {
  return (
    <div
      data-testid="eula-page"
      className="min-h-screen bg-background text-foreground"
    >
      <header className="border-b border-border bg-surface/60 backdrop-blur sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link
            to="/login"
            className="text-sm font-semibold tracking-tight text-primary hover:opacity-80 transition-opacity"
            data-testid="eula-back-link"
          >
            ← Lovi Integration
          </Link>
          <span className="text-xs text-muted-foreground uppercase tracking-wider">
            Legal
          </span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="space-y-2 mb-10">
          <p className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
            Effective Date · February 12, 2026
          </p>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight">
            End User License Agreement
          </h1>
          <p className="text-base text-muted-foreground pt-2">
            Lovi Integration · TikTok Shop ↔ QuickBooks Online sync platform
            operated by CPN Trade Inc. / Lovi Creation.
          </p>
        </div>

        <section className="prose prose-slate dark:prose-invert max-w-none space-y-6 text-base leading-relaxed">
          <h2 className="text-xl font-semibold mt-8">1. Acceptance of Terms</h2>
          <p className="text-muted-foreground">
            By accessing or using the Lovi Integration platform (the
            “Service”), you agree to be bound by this End User License
            Agreement (“EULA”). If you do not agree, do not use the Service.
            This EULA is a binding agreement between you and CPN Trade Inc.
          </p>

          <h2 className="text-xl font-semibold mt-8">2. License Grant</h2>
          <p className="text-muted-foreground">
            Subject to your compliance with this EULA, CPN Trade Inc. grants
            you a limited, non-exclusive, non-transferable, revocable license
            to access and use the Service solely for your internal business
            purposes of synchronizing TikTok Shop orders with QuickBooks
            Online.
          </p>

          <h2 className="text-xl font-semibold mt-8">3. Authorized Use</h2>
          <p className="text-muted-foreground">
            You may only use the Service with QuickBooks Online accounts and
            TikTok Shop accounts that you own or are authorized to access. You
            are responsible for maintaining the confidentiality of your
            credentials and for all activities under your account.
          </p>

          <h2 className="text-xl font-semibold mt-8">4. Restrictions</h2>
          <p className="text-muted-foreground">
            You agree not to: (a) reverse engineer, decompile, or disassemble
            the Service; (b) resell or sublicense the Service; (c) use the
            Service to violate any law, including data protection laws or
            third-party rights; (d) interfere with the integrity or
            performance of the Service.
          </p>

          <h2 className="text-xl font-semibold mt-8">5. Data &amp; Privacy</h2>
          <p className="text-muted-foreground">
            Your use of the Service is also governed by our{' '}
            <Link
              to="/privacy"
              className="text-primary underline underline-offset-4 hover:opacity-80"
              data-testid="eula-privacy-link"
            >
              Privacy Policy
            </Link>
            , which describes how we collect, use, and protect data accessed
            through TikTok Shop and QuickBooks Online APIs.
          </p>

          <h2 className="text-xl font-semibold mt-8">6. Third-Party Services</h2>
          <p className="text-muted-foreground">
            The Service integrates with third-party platforms (TikTok Shop,
            Intuit QuickBooks Online). Your use of those platforms is subject
            to their own terms. CPN Trade Inc. is not responsible for the
            availability or behaviour of third-party services.
          </p>

          <h2 className="text-xl font-semibold mt-8">7. Disclaimer of Warranties</h2>
          <p className="text-muted-foreground">
            The Service is provided “as is” and “as available” without
            warranties of any kind, express or implied. We do not warrant that
            the Service will be uninterrupted, error-free, or that data
            synchronization will be free of discrepancies.
          </p>

          <h2 className="text-xl font-semibold mt-8">8. Limitation of Liability</h2>
          <p className="text-muted-foreground">
            To the maximum extent permitted by law, CPN Trade Inc. shall not
            be liable for any indirect, incidental, special, consequential, or
            punitive damages arising out of or in connection with your use of
            the Service.
          </p>

          <h2 className="text-xl font-semibold mt-8">9. Termination</h2>
          <p className="text-muted-foreground">
            We may suspend or terminate your access to the Service at any time
            if you breach this EULA. Upon termination, your right to use the
            Service ceases immediately.
          </p>

          <h2 className="text-xl font-semibold mt-8">10. Governing Law</h2>
          <p className="text-muted-foreground">
            This EULA shall be governed by and construed in accordance with
            the laws of the State of New York, United States, without regard
            to its conflict of law principles.
          </p>

          <h2 className="text-xl font-semibold mt-8">11. Contact</h2>
          <p className="text-muted-foreground">
            Questions about this EULA may be sent to{' '}
            <a
              href="mailto:admin@lovicreation.shop"
              className="text-primary underline underline-offset-4 hover:opacity-80"
              data-testid="eula-contact-email"
            >
              admin@lovicreation.shop
            </a>
            .
          </p>
        </section>

        <footer className="mt-16 pt-8 border-t border-border text-sm text-muted-foreground flex items-center justify-between">
          <span>© 2026 CPN Trade Inc. / Lovi Creation</span>
          <Link
            to="/privacy"
            className="hover:text-foreground transition-colors"
            data-testid="eula-footer-privacy"
          >
            Privacy Policy →
          </Link>
        </footer>
      </main>
    </div>
  );
}
